"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCUpIcon16Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCUpIcon16Solid = forwardRef_1.forwardRef('ArrowCUpIcon16Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { d: "M2.622 10.89a1.25 1.25 0 0 1-.012-1.768L6.403 5.28a2.25 2.25 0 0 1 3.193-.01l3.788 3.788a1.25 1.25 0 0 1-1.768 1.767l-3.61-3.61-3.616 3.663a1.25 1.25 0 0 1-1.768.012Z" })));
});
